export default __webpack_public_path__ + "static/media/PHOTO-2021-02-24-10-39-1717.724e606f.jpg";